import {
  COMMISSION_BENCHMARK_ACCOUNT_BREAKDOWN_PATH,
  COMMISSION_BENCHMARK_ACCOUNTS_PATH,
  COMMISSION_BENCHMARK_ACCOUNTS_CSV_PATH,
  COMMISSION_BENCHMARK_RECALCULATE_ACCOUNT_SPREAD_PATH,
  COMMISSION_BENCHMARK_REFERENCE_PATH,
} from '../../../../constants'
import AbstractService from '../../../../services/AbstractService'

import {
  CommissionBenchmarkAccountBreakdownResponse,
  CommissionBenchmarkAccountOverviewResponse,
  CommissionBenchmarkRecalculateAccountSpreadResponse,
  CommissionBenchmarkReferenceRequest,
  CommissionBenchmarkReferenceResponse,
  GetCommissionBenchmarkOverviewRequest,
} from './types'

class CommissionBenchmarkApiService extends AbstractService {
  getReference = (params?: CommissionBenchmarkReferenceRequest) =>
    this.request<CommissionBenchmarkReferenceResponse>(
      COMMISSION_BENCHMARK_REFERENCE_PATH,
      'get',
      false,
      undefined,
      { params },
    )

  getAccountsOverview = (data: GetCommissionBenchmarkOverviewRequest) =>
    this.request<CommissionBenchmarkAccountOverviewResponse>(
      COMMISSION_BENCHMARK_ACCOUNTS_PATH,
      'post',
      false,
      data,
    )

  getAccountBreakdown = (
    accountId: number,
    onlyWorseThanNuvesto?: boolean,
    nuvestoAccountType?: CommissionBenchmarkReferenceRequest['nuvestoAccountType'],
    benchmarkType?: CommissionBenchmarkReferenceRequest['benchmarkType'],
  ) =>
    this.request<CommissionBenchmarkAccountBreakdownResponse>(
      COMMISSION_BENCHMARK_ACCOUNT_BREAKDOWN_PATH,
      'post',
      false,
      { accountId, onlyWorseThanNuvesto, nuvestoAccountType, benchmarkType },
    )

  recalculateAccountSpread = (accountId: number) =>
    this.request<CommissionBenchmarkRecalculateAccountSpreadResponse>(
      COMMISSION_BENCHMARK_RECALCULATE_ACCOUNT_SPREAD_PATH,
      'post',
      false,
      { accountId },
    )

  getAccountsOverviewCsv = (
    params: Pick<
      GetCommissionBenchmarkOverviewRequest,
      | 'showDemo'
      | 'showProp'
      | 'showCfd'
      | 'onlyWorseThanNuvesto'
      | 'pricingModel'
      | 'benchmarkType'
      | 'nuvestoAccountType'
      | 'search'
    >,
  ) =>
    this.getBlobWithFilename<Blob>({
      url: COMMISSION_BENCHMARK_ACCOUNTS_CSV_PATH,
      params,
    })
}

export const CommissionBenchmarkService = new CommissionBenchmarkApiService()
